import React from 'react';
import logoCerogrado from '../../images/logo.png';
import logoTrampoline from '../../images/logo-1.png';

export default function ApplicationLogo({ className, isLarge = true, store }) {
    const size = isLarge? 'h-16 sm:h-20' : 'h-8 sm:h-10';
    //console.log('llego el domain?', domain)
    return (
        <img src={store === 'cerogrado' ? logoCerogrado : logoTrampoline} className={`w-auto ${size} ${className}`}/>
    );
}
